// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__15I2Q","errorLogs":"styles_errorLogs__1JW-Q"};